import { dk } from './dk'
import { en } from './en'
import { nl } from './nl'

export const translations = {
  'en-GB': en,
  'nl-NL': nl,
  'da-DK': dk,
}
